/**
 * 封装消息提示框
 * type: success warning info error
 */
import { Message } from 'element-ui';
export const msgtip= (msg,type="warning")=> {
  Message({
    message: msg,
    type: type,
    duration:3000
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/msgtip.js